/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, CancelToken, AxiosInstance } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
import { makeCodedException, makeContent } from 'utils';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

export interface IDashboard {
    dashboardData(
        locationIds: number[] | null | undefined,
        includeInvoices: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<DashboardData>;
}

export const BASE_URL_TOKEN_Dashboard = symbolToken<string>('BASE_URL_TOKEN', false);

@injectable()
export class Dashboard implements IDashboard {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private axios: AxiosInstance, private readonly baseUrl = '') {}

    dashboardData(
        locationIds: number[] | null | undefined,
        includeInvoices: boolean | undefined,
        cancelToken?: CancelToken
    ): AxiosPromise<DashboardData> {
        let url_ = '/v1/customerportal2/dashboard?';
        if (locationIds !== undefined && locationIds !== null)
            locationIds &&
                locationIds.forEach(item => {
                    url_ += 'locationIds=' + encodeURIComponent('' + item) + '&';
                });
        if (includeInvoices === null)
            throw new Error("The parameter 'includeInvoices' cannot be null.");
        else if (includeInvoices !== undefined)
            url_ += 'includeInvoices=' + encodeURIComponent('' + includeInvoices) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_ = <AxiosRequestConfig>{
            baseURL: this.baseUrl,
            cancelToken,
            url: url_,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        };

        return makeCodedException(this.axios.request<DashboardData>(options_));
    }
}

export interface DashboardData {
    customersInvoices: DashboardCustomerInvoicesModel[];
    upcomingAppointments: AppointmentModel[];
    latestEstimateContainers: EstimateContainerWebModel[];
    visitsDueMemberships?: DashboardMembershipSummaryModel[] | undefined;
}

export interface DashboardCustomerInvoicesModel {
    id: number;
    name: string;
    address: AddressModel;
    invoices: DashboardInvoiceModel[];
}

export interface AddressModel {
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    unit?: string | undefined;
}

export interface DashboardInvoiceModel {
    id: string;
    locationId?: number | undefined;
    totalBalanceDue: number;
}

export interface AppointmentModel {
    id: number;
    number: string;
    jobId: number;
    proposalId: number;
    status: AppointmentStatus;
    isConfirmed: boolean;
    startDate: Date;
    endDate: Date;
    jobType: JobTypeModel;
    location: LocationModel;
    invoice?: InvoiceModel | undefined;
    invoices?: InvoiceModel[] | undefined;
    contract?: ContractModel | undefined;
}

export enum AppointmentStatus {
    Scheduled = 0,
    InProgress = 1,
    Completed = 2,
}

export interface JobTypeModel {
    id: number;
    name: string;
}

export interface LocationModel {
    id: number;
    name: string;
    address?: AddressModel | undefined;
}

export interface InvoiceModel {
    id: string;
    number: string;
    summary?: string | undefined;
    isPaid: boolean;
    isAccessible: boolean;
}

export interface ContractModel {
    id: number;
    name: string;
}

export interface EstimateContainerWebModel {
    id: string;
    name: string;
    estimateContainerType: EstimateContainerType;
    description?: string | undefined;
    estimates: EstimateModel[];
    createdOn: Date;
    jobType?: JobTypeModel | undefined;
    jobStatus?: JobStatus | undefined;
    serviceLocation?: LocationModel | undefined;
    showEstimateTotalPrice?: boolean | undefined;
    documentLink?: string | undefined;
    tenantId: number;
    jobId?: number | undefined;
    customer?: EstimateCustomerWebModel | undefined;
}

export enum EstimateContainerType {
    EstimateBundle = 0,
    Opportunity = 1,
    ContractProposal = 2,
}

export interface EstimateModel {
    id: number;
    name: string;
    summary: string;
    status: EstimateStatus;
    expired: boolean;
    optionName?: string | undefined;
    optionColorHex?: string | undefined;
    imageUrl?: string | undefined;
    totalPrice?: number | undefined;
    selected?: boolean | undefined;
    createdById?: number | undefined;
    businessUnitId?: number | undefined;
}

export enum EstimateStatus {
    Open = 0,
    Sold = 1,
    Dismissed = 2,
}

export enum JobStatus {
    Scheduled = 0,
    Dispatched = 1,
    InProgress = 2,
    Hold = 3,
    Completed = 4,
    Canceled = 5,
}

export interface EstimateCustomerWebModel {
    id: number;
    firstName?: string | undefined;
    middleNames?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
}

export interface DashboardMembershipSummaryModel {
    id: string;
    customerId: number;
    name: string;
    location: LocationModel;
    isAllLocations: boolean;
    isRenewed: boolean;
    visitDue: boolean;
    status: MembershipStatus;
    from?: Date | undefined;
    to?: Date | undefined;
    nextBillingDate?: Date | undefined;
}

export enum MembershipStatus {
    Active = 0,
    Suspended = 1,
    Expired = 2,
    Canceled = 3,
    Deleted = 4,
}
